import { useI18n } from '@/hooks/web/useI18n'

const { t } = useI18n()

export default [
  {
    menuName: t('router.accessPermissionManagement'),
    menuKey: 'ACCESS_PERMISSION_MANAGEMENT',
    menuId: 21,
    parentId: 20
  },
  {
    menuName: t('router.phoneUserManage'),
    menuKey: 'kol:phoneCallElevatorIntro',
    menuId: 22,
    parentId: 21
  },
  {
    menuName: t('router.koneOnline'),
    menuKey: 'kol:online',
    menuId: 3,
    parentId: 0
  },
  {
    menuName: t('router.systemSetting'),
    menuKey: 'SYSTEM_SETTINGS',
    menuId: 5,
    parentId: 0
  },
  {
    menuName: t('router.projectInfoConfiguration'),
    menuKey: 'kedex:basic:configuration',
    menuId: 1,
    parentId: 5
  },
  {
    menuName: t('router.dataAndSystemLogs'),
    menuKey: 'DATA_AND_SYSTEM_LOGS',
    menuId: 4,
    parentId: 5
  }
]
